import React, { Component, createRef, forwardRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Send,
  ExpandMore,
  // ExpandLess,
  Close,
  Email,
  Call,
  // ArrowDropDown,
  Schedule,
  PictureAsPdf,
  Audiotrack,
  VideoLabel,
  Description,
} from '@material-ui/icons'
import { MessageReplyText } from 'mdi-material-ui'
import {
  CircularProgress,
  Hidden,
  IconButton,
  withStyles,
  Tooltip,
} from '@material-ui/core'
//import getUrls from 'get-urls'
import { list, read, create } from 'actions/data'
// import EmailEditor from './EmailEditor'
import {
  sendSMSInbox,
  sendEmailInbox,
  selectConversation,
  toggleMessageMenu,
  whatever,
  changeTo,
} from 'actions/inbox'
import shortener_urls from 'utils/ShortenerUrl'
import { DATA_API_URL } from 'utils/AllURLs'
import MessageTypeMenu from './MessageTypeMenu'
import EmojiMenu from './EmojiMenuPopper'
import PhoneCall from './PhoneCall'
import Acknowledgement from 'components/Acknowledgement'
import { toggleModal } from 'actions/acknowledgements'
import FromNumberMenu from './FromNumberMenu'
import FromEmailMenu from './FromEmailMenu'
import './Input.css'
import S3ManagerMenu from './S3ManagerMenu'
import Button from 'components/theme/Button'
import TextareaAutosize from 'react-textarea-autosize'
import { toggleDialog } from 'actions/view'
import SchedulingDialog from './SchedulingDialog'
import { EditorUtils } from '@progress/kendo-react-editor'
import Subject from './Subject'
import './editor.css'
import Editor from 'components/ReactEditor'
import { editorChange } from 'actions/editor'
import { handleCalendarChange } from 'actions/tasks'
import { fiveMinutesFromNow } from './SchedulingDialog'
import TooltipContent from 'components/A2P10DLC/TooltipContent'

const EmailEmojiMenu = ({ view }) => {
  return (
    <EmojiMenu
      // disabled={!canInsert}
      onEmojiClick={emoji => {
        EditorUtils.insertNode(view, view.state.schema.text(emoji))
      }}
    />
  )
}

const AttachmentPreview = ({ mediaUrl, onClose }) => {
  const getFileType = url => {
    // Extract mime type from data URL if present
    if (url.startsWith('data:')) {
      const mime = url.split(';')[0].split(':')[1]
      return mime
    }

    // Otherwise try to determine from file extension
    const extension = url.split('.').pop().toLowerCase()
    const extensionToMime = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      mp3: 'audio/mpeg',
      mp4: 'video/mp4',
      mov: 'video/quicktime',
      // Add more mappings as needed
    }
    return extensionToMime[extension] || 'unknown'
  }

  const fileType = getFileType(mediaUrl)
  const isImage = fileType.startsWith('image/')
  const isAudio = fileType.startsWith('audio/')
  const isVideo = fileType.startsWith('video/')
  const isPDF = fileType === 'application/pdf'

  const getIcon = () => {
    if (isPDF)
      return <PictureAsPdf style={{ fontSize: 48, color: '#014c94' }} />
    if (isAudio)
      return <Audiotrack style={{ fontSize: 48, color: '#014c94' }} />
    if (isVideo)
      return <VideoLabel style={{ fontSize: 48, color: '#014c94' }} />
    if (!isImage)
      return <Description style={{ fontSize: 48, color: '#014c94' }} />
    return null
  }

  return (
    <div>
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          padding: 8,
          border: '1px solid #e0e0e0',
          borderRadius: 4,
          backgroundColor: '#f5f5f5',
        }}
      >
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 3,
            top: 3,
            borderRadius: '50%',
            backgroundColor: '#014c94',
            cursor: 'pointer',
            height: 24,
            width: 24,
            zIndex: 1,
          }}
        >
          <Close style={{ color: '#fff' }} />
        </div>
        {isImage ? (
          <img
            style={{
              height: 100,
              maxWidth: '100%',
              display: 'block',
            }}
            alt="Attachment"
            src={mediaUrl}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '8px 16px',
            }}
          >
            {getIcon()}
            <span
              style={{
                marginTop: 4,
                fontSize: 12,
                color: '#666',
                maxWidth: 150,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {mediaUrl.split('/').pop()}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

const ConnectedInput = connect(
  state => {
    const conversationSelected = state.inbox.conversationSelected
    const username = state.auth?.session?.idToken?.payload?.['cognito:username']

    return {
      contact_id: state.inbox.conversationSelected,
      from_number: state.inbox.fromNumberSelected.phone_number,
      contactSelected: state.inbox.contactSelected,
      messageType: state.inbox.to.current.type,
      conversationSelected,
      conversation: state.inbox.conversation,
      editor: state.editor,
      url: state.data?.url,
      to: state.inbox.to.current.value,
      contact:
        (((state.inbox.contactSelected && state.inbox.contactSelected.id) ||
          state.inbox.conversationSelected) &&
          state.contacts.contactsWithEmailsByID[
            (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
              state.inbox.conversationSelected
          ]) ||
        {},
      acknowledgedMethods: state.acknowledgement.acknowledgedMethods,
      // TODO: [ML-69] change this
      default_email_from:
        state.data['account/preference'] &&
        state.data['account/preference'].preferences &&
        state.data['account/preference'].preferences.default_email_from,
      sending: state.inbox.sending,
      'email/verify_default_address_status':
        state.data['email/verify_default_address_status'] &&
        state.data['email/verify_default_address_status'].status,
      messageMenuOpen: state.inbox.messageMenuOpen,
      whateverState: state.inbox.whatever,
      smsInputOverride: state.inbox.smsInputOverride,
      smsDraft:
        state.data.conversationdraft?.[
          `${conversationSelected}-sms-${username}`
        ]?.content || '',
      emailDraft:
        state.data.conversationdraft?.[
          `${conversationSelected}-email-${username}`
        ]?.content || '<p></p>',
      username,
      approvedCampaignExists: Object.values(
        Object.values(state.data.a2p10dlc || {})?.[0]?.campaigns || {},
      ).some(
        campaign => campaign?.campaignStatus?.slice?.(0, 8) === 'VERIFIED',
      ),
      a2p10dlcLoadStatus: state.loadStatus.a2p10dlc,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        list,
        sendSMS: sendSMSInbox,
        sendEmail: sendEmailInbox,
        read,
        toggleModal,
        toggleMessageMenu,
        whatever,
        changeTo,
        toggleDialog,
        create,
        editorChange,
        handleCalendarChange,
      },
      dispatch,
    ),
)(
  withStyles(theme => ({
    iconButtonRoot: {
      backgroundColor: '#014c94',
      color: '#fff',
      padding: 5,
      '@media (max-width: 1170px)': {
        padding: 12,
      },
      '&:hover': {
        backgroundColor: '#002f5c',
      },
    },
    textAreaAutoSize: {
      borderWidth: 0,
      marginLeft: 62,
      width: 'calc(100% - 149px)',
      // minHeight: 48,
      padding: 8,
      font: '16px Roboto, sans-serif',
      // position: 'absolute',
      // top: '50%',
      // transform: 'translate(0, -50%)',
      marginTop: 6,
      resize: 'none',
      // textOverflow: 'ellipsis',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 33,
        width: 'calc(100% - 84px)',
      },
    },
    sendButtonRoot: {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: '#014c94',
      padding: '5px 5px 5px 15px',
      right: 40,
      '&:hover': {
        backgroundColor: '#002f5c',
      },
      [theme.breakpoints.down('sm')]: {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
        right: 5,
        padding: 7,
      },
    },
  }))(
    class Input extends Component {
      constructor(props) {
        super(props)
        this.textInput = createRef()
        this.fromMenuRef = createRef()
        this.sendButtonRef = createRef()
        this.state = {
          text: '',
          anchorEl: null,
          selectionStart: 0,
          selectionEnd: 0,
          length: 0,
          media_url: undefined,
          openURLDialog: false,
          typing: false,
          hasTyped: null,

          editor: props.editor,
          timeoutId: null,
          emailTyping: false,
          emailHasTyped: false,
        }
      }

      componentDidMount() {
        console.log('Input componentDidMount')
        this.props.list('phonenumbers')
        this.props.list('url', 'url_code', shortener_urls.api_url + '/list')

        if (this.props.conversationSelected) {
          console.log(
            'Inbox componentDidMount hits if (this.props.conversationSelected)...',
          )
          this.props.list(
            'conversationdraft',
            null,
            `${DATA_API_URL}/conversationdraft/secondary_id-username/${this.props.conversationSelected}`,
          )
        }

        if (this.props.smsDraft) {
          this.setState({ text: this.props.smsDraft })
        }

        if (this.props.emailDraft) {
          this.setState({ editor: this.props.emailDraft })
        }

        if (!this.props.a2p10dlcLoadStatus) {
          this.props.list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
        }
      }

      componentDidUpdate(prevProps) {
        //set state.text to redux.openai.selected_prediction
        console.log('Input componentDidUpdate')

        if (this.props.messageMenuOpen !== prevProps.messageMenuOpen) {
          setTimeout(() => {
            this.props.whatever(this.props.forwardedRef?.current?.offsetHeight)
            // this.forceUpdate()
          }, 300)
        }

        if (
          this.props.smsInputOverride &&
          this.props.smsInputOverride !== prevProps.smsInputOverride
        ) {
          this.setState({ text: this.props.smsInputOverride })
        }

        if (
          this.props.conversationSelected !== prevProps.conversationSelected
        ) {
          this.setState({ emailHasTyped: false })
        }

        if (
          this.props.conversationSelected &&
          this.props.conversationSelected !== prevProps.conversationSelected
        ) {
          this.setState({ emailHasTyped: false })

          this.props.list(
            'conversationdraft',
            null,
            `${DATA_API_URL}/conversationdraft/secondary_id-username/${this.props.conversationSelected}`,
          )
        }

        if (
          this.props.smsDraft !== prevProps.smsDraft &&
          !this.state.hasTyped
        ) {
          this.setState({ text: this.props.smsDraft })
        }

        if (
          /* this.props.emailDraft &&
          this.props.emailDraft !== '<p></p>' && */
          this.props.emailDraft !== prevProps.emailDraft &&
          !this.state.emailHasTyped
        ) {
          console.log('EmailComponent componentDidUpdate fills condition')
          // this.props.editorChange(this.props.emailDraft)
          this.setState({ editor: this.props.emailDraft })
        }
      }

      componentWillUnmount() {
        const { timeoutId } = this.state
        if (timeoutId) {
          clearTimeout(timeoutId)
        }
      }

      handleInputChange = htmlString => {
        const { timeoutId } = this.state
        const { editorChange, create, conversationSelected, username } =
          this.props

        clearTimeout(timeoutId)
        this.setState({
          emailTyping: true,
          emailHasTyped: true,
          editor: htmlString,
        })

        const newTimeoutId = setTimeout(() => {
          create({
            entityType: 'conversationdraft',
            entity: {
              content: htmlString,
              editor: 'email',
              secondary_id: conversationSelected,
              id: `${conversationSelected}-email-${username}`,
            },
            url: `${DATA_API_URL}/conversationdraft`,
            hasSchema: false,
            snackbarMessage: 'none',
          })
          this.setState({ emailTyping: false, timeoutId: null })
          editorChange(htmlString)
        }, 1500)

        this.setState({ timeoutId: newTimeoutId })
      }

      sendSMS = () => {
        const {
          contact_id,
          from_number,
          contactSelected,
          to,
          conversationSelected,
          conversation,
          read,
          sendSMS,
          // create,
          //  url,
        } = this.props
        const { text, media_url } = this.state
        //set redux.openai.selected_prediction to ''

        /*TODO: Call get urls,
				check for urls greater than length 6,
				presents the user with list of checkboxed long urls, they can opt-in to shrink the urls*/
        // let found_urls = []
        // if (!text.includes('@')) {
        //   found_urls = Array.from(getUrls(text, { normalizeProtocol: false }))
        // }

        // const long_url_object = Object.keys(url).reduce((acc, el) => {
        //   acc[url[el].long_url] = url[el].url_code
        //   return acc
        // }, {})

        // const requests = []
        // const urls_to_replace = []
        // console.log('urls', found_urls)

        // for (let i = 0; i < found_urls.length; i++) {
        //   let found_url = found_urls[i]
        //   if (long_url_object[found_url]) {
        //     urls_to_replace.push({
        //       long_url: found_url,
        //       url_code: long_url_object[found_url],
        //     })
        //   } else if (found_url.search('r33.ch') === -1) {
        //     requests.push(
        //       create({
        //         entity: {
        //           long_url: found_url,
        //         },
        //         entityType: 'url',
        //         hasSchema: false,
        //         url: shortener_urls.api_url,
        //         snackbarMessage: 'Predictions generated!',
        //       }).then(payload => {
        //         urls_to_replace.push({
        //           long_url: payload.long_url,
        //           url_code: payload.url_code,
        //         })
        //       }),
        //     )
        //   }
        // }
        //Promise.allSettled(requests).then(result => {
        // let replaced_text = text.replace('http://', '')
        // console.log('urls_to_replace', urls_to_replace)
        // for (let i = 0; i < urls_to_replace.length; i++) {
        //   replaced_text = replaced_text.replace(
        //     urls_to_replace[i].long_url.replace('http://', ''),
        //     'https://' +
        //       shortener_urls.public_url +
        //       '/' +
        //       urls_to_replace[i].url_code,
        //   )
        // }
        // console.log('replaced', replaced_text)
        sendSMS({
          media_url,
          text, //: replaced_text,
          contact_id: (contactSelected && contactSelected.id) || contact_id,
          contact:
            contactSelected || (conversationSelected && conversation.contact),
          to,
          from_number,
          contactSelected: Boolean(contactSelected),
          last_interaction: new Date().toISOString(),
          length: conversation.conversation && conversation.conversation.length,
        }).then(() => {
          this.setState({ text: '', media_url: undefined })

          this.props.create({
            entityType: 'conversationdraft',
            entity: {
              content: '',
              editor: 'sms',
              secondary_id: this.props.conversationSelected,
              id: `${this.props.conversationSelected}-sms-${this.props.username}`,
            },
            url: `${DATA_API_URL}/conversationdraft`,
            hasSchema: false,
            snackbarMessage: 'none',
          })

          read(
            (contactSelected && contactSelected.id) || contact_id,
            'inbox',
            'inbox/conversation',
            'contact_id',
          ).then(() =>
            // this isn't getting called...not sure if we need it
            selectConversation(
              (contactSelected && contactSelected.id) || contact_id,
            ),
          )
        })
        .catch(error => {
          // On failure, leave the input state as-is
          console.error('Failed to send SMS:', error)
          // Optionally show an error message to the user
        })
      }

      sendEmail = () => {
        const {
          contact_id,
          contactSelected,
          conversationSelected,
          conversation,
          create,
        } = this.props

        this.props
          .sendEmail(
            {
              last_interaction: new Date().toISOString(),
              contactSelected: Boolean(contactSelected),
              contact_id: (contactSelected && contactSelected.id) || contact_id,
              contact:
                contactSelected ||
                (conversationSelected && conversation.contact),
              length:
                conversation.conversation && conversation.conversation.length,
            },
            this.state.editor,
          )
          .then(() => {
            this.setState({ editor: '' })
            console.log('hits then')
            create({
              entityType: 'conversationdraft',
              entity: {
                content: '',
                editor: 'email',
                secondary_id: conversationSelected,
                id: `${conversationSelected}-email-${this.props.username}`,
              },
              url: `${DATA_API_URL}/conversationdraft`,
              hasSchema: false,
              snackbarMessage: 'none',
            })

            this.props.read(
              (contactSelected && contactSelected.id) || contact_id,
              'inbox',
              'inbox/conversation',
              'contact_id',
            )
          })
      }

      render() {
        const {
          contact_id,
          contactSelected,
          messageType,
          to,
          // conversationSelected,
          conversation,
          acknowledgedMethods,
          forwardedRef,
          from_number,
          messageMenuOpen,
          toggleMessageMenu,
          classes,
          whatever,
          contact,
          approvedCampaignExists,
          // read,
        } = this.props

        const sendButtonDisabled =
          (messageType === 'email' &&
            (!this.state.editor || this.state.editor === '<p></p>')) ||
          (messageType === 'text' &&
            ((!this.state.text && !this.state.media_url) ||
              !approvedCampaignExists)) ||
          !to ||
          (from_number === 'none' &&
            (messageType === 'text' || messageType === 'call')) ||
          ((!this.props.default_email_from ||
            this.props['email/verify_default_address_status'] !== 'success') &&
            messageType === 'email')

        const component = {
          text: (
            <TextareaAutosize
              className={classes.textAreaAutoSize}
              maxRows={5}
              onHeightChange={(height, additionalInfo) => {
                whatever(forwardedRef?.current?.offsetHeight)
              }}
              ref={this.textInput}
              disabled={this.props.sending}
              onChange={e => {
                clearTimeout(this.timeout)
                this.setState({
                  text: e.target.value,
                  typing: true,
                  hasTyped: true,
                })
                this.timeout = setTimeout(() => {
                  this.props.create({
                    entityType: 'conversationdraft',
                    entity: {
                      content: this.state.text,
                      editor: 'sms',
                      secondary_id: this.props.conversationSelected,
                      id: `${this.props.conversationSelected}-sms-${this.props.username}`,
                    },
                    url: `${DATA_API_URL}/conversationdraft`,
                    hasSchema: false,
                    snackbarMessage: 'none',
                  })
                  this.setState({ typing: false })
                }, 1500)
              }}
              value={this.state.text}
              placeholder={
                !contact_id && !contactSelected
                  ? 'Select a conversation or a contact to message'
                  : `Send a text message to ${to}, or select another number`
              }
              onBlur={e => {
                e.preventDefault()
                const { selectionStart, selectionEnd } = e.target
                this.setState({
                  selectionStart,
                  selectionEnd,
                  length: e.target.value.length,
                })
              }}
            />
          ),
          email: (
            <div style={{ paddingBottom: 47 }}>
              <Subject setTyping={val => this.setState({ emailTyping: val })} />
              <Editor
                disabled={!to}
                tools={[EmailEmojiMenu]}
                value={this.state.editor}
                onChange={this.handleInputChange}
              />
            </div>
          ),
          call: <PhoneCall />,
        }

        const sendButton = (
          <IconButton
            // color="secondary"
            classes={{ root: classes.sendButtonRoot }}
            onClick={() => {
              if (sendButtonDisabled) {
                console.log('disabled')
                return
              }

              const contact = contactSelected || conversation.contact

              if (messageType === 'text') {
                if (
                  !acknowledgedMethods[to] &&
                  contact.phones &&
                  contact.phones.find(
                    phone => phone.number === to && phone.opt_in === false,
                  )
                ) {
                  this.props.toggleModal({
                    modalOpen: true,
                    acknowledgementText: `You are about to send a message to a contact's phone number that has opted out of marketing communication. You acknowledge that sending any marketing material is in violation of the CAN-SPAM act. You should only send communication to this contact for non-marketing purposes. You can find more acceptable communication types at the CAN-SPAM Act website (https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business).`,
                    messageType: 'sms',
                    contactMethod: to,
                  })
                } else {
                  this.sendSMS()
                }
              }

              if (messageType === 'email') {
                if (
                  !acknowledgedMethods[to] &&
                  contact.email &&
                  contact.email.find(
                    email => email.address === to && email.opt_in === false,
                  )
                ) {
                  this.props.toggleModal({
                    modalOpen: true,
                    acknowledgementText: `You are about to send a message to a contact's email address that has opted out of marketing communication. You acknowledge that sending any marketing material is in violation of the CAN-SPAM act. You should only send communication to this contact for non-marketing purposes. You can find more acceptable communication types at the CAN-SPAM Act website (https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business).`,
                    messageType: 'email',
                    contactMethod: to,
                  })
                } else {
                  this.sendEmail()
                }
              }
            }}
            // disabled={sendButtonDisabled}
            style={{
              position: 'absolute',
              bottom: 5,
              color: sendButtonDisabled ? 'rgba(0, 0, 0, 0.26)' : '#fff',
              display: messageMenuOpen ? undefined : 'none',
              backgroundColor: sendButtonDisabled
                ? 'rgba(0, 0, 0, 0.12)'
                : undefined,
              cursor: sendButtonDisabled ? 'default' : undefined,
            }}
          >
            <Send />
          </IconButton>
        )

        const sendAndSchedule = (
          <>
            {messageType === 'text' && !approvedCampaignExists ? (
              <Tooltip interactive title={<TooltipContent />}>
                {sendButton}
              </Tooltip>
            ) : (
              sendButton
            )}
            <Hidden smDown>
              <IconButton
                classes={{ root: classes.sendButtonRoot }}
                onClick={() => {
                  if (sendButtonDisabled) {
                    console.log('disabled')
                    return
                  }

                  this.props.toggleDialog({
                    dialog: 'scheduling',
                    open: true,
                    options: {
                      text: this.state.text,
                    },
                  })

                  this.props.handleCalendarChange(fiveMinutesFromNow())
                }}
                // disabled={sendButtonDisabled}
                style={{
                  cursor: sendButtonDisabled ? 'default' : undefined,
                  position: 'absolute',
                  padding: 5,
                  right: 5,
                  bottom: 5,
                  color: sendButtonDisabled ? 'rgba(0, 0, 0, 0.26)' : '#fff',
                  display: messageMenuOpen ? undefined : 'none',
                  backgroundColor: sendButtonDisabled
                    ? 'rgba(0, 0, 0, 0.12)'
                    : undefined,
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderTopRightRadius: '50%',
                  borderBottomRightRadius: '50%',
                  borderLeft: sendButtonDisabled
                    ? '1px solid rgba(0, 0, 0, 0.26)'
                    : '1px solid #002f5c',
                }}
              >
                <Schedule />
              </IconButton>
            </Hidden>
          </>
        )

        return (
          <>
            <div
              ref={forwardedRef}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                maxHeight: messageMenuOpen ? 800 : 60,
                overflowY: messageMenuOpen ? undefined : 'hidden',
                transition: 'max-height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
              }}
              // className={
              //   messageMenuOpen ? 'inputHeaderMenuOpen' : 'inputHeaderMenuClosed'
              // }
            >
              <div>
                <div
                  style={{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#f5f5f5',
                      borderTop: '1px solid #e5e5e5',
                      overflow: 'hidden',
                    }}
                    ref={this.fromMenu}
                  >
                    <div
                      style={{
                        padding: 3,
                        width: '100%',
                        overflow:
                          messageType === 'email' ? 'hidden' : 'initial',
                        position: 'relative',
                      }}
                    >
                      {messageMenuOpen ? (
                        <>
                          <div className="toFrom">
                            To:{' '}
                            <MessageTypeMenu
                              cancelAttachment={() =>
                                this.setState({ media_url: undefined })
                              }
                            />{' '}
                          </div>
                          {messageType === 'email' ? (
                            <div className="toFrom">
                              From: <FromEmailMenu />
                            </div>
                          ) : messageType === 'text' ||
                            messageType === 'call' ? (
                            <div className="toFrom">
                              From: <FromNumberMenu />
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <div style={{ textAlign: 'center', padding: '5px 0' }}>
                          {contact.phones && (
                            <Button
                              style={{ marginRight: 5, padding: '8px 12px' }}
                              disabled={!contact.phones}
                              onClick={() => {
                                toggleMessageMenu().then(() =>
                                  whatever(forwardedRef?.current?.offsetHeight),
                                )
                                if (this.props.messageType !== 'text') {
                                  if (this.props.messageType === 'call') {
                                    this.props.changeTo(
                                      'text',
                                      this.props.to,
                                      contact.id,
                                    )
                                  } else {
                                    this.props.changeTo(
                                      'text',
                                      contact?.phones?.[0]?.number,
                                      contact.id,
                                    )
                                  }
                                }
                                this.setState({ media_url: undefined })
                              }}
                              variant="contained"
                              color="secondary"
                              size="large"
                            >
                              <MessageReplyText style={{ marginRight: 5 }} />
                              Text
                            </Button>
                          )}
                          {contact.email && (
                            <Button
                              style={{ marginRight: 5, padding: '8px 12px' }}
                              disabled={!contact.email}
                              onClick={() => {
                                toggleMessageMenu().then(() =>
                                  whatever(forwardedRef?.current?.offsetHeight),
                                )
                                if (this.props.messageType !== 'email') {
                                  this.props.changeTo(
                                    'email',
                                    contact?.email?.[0].address,
                                    contact.id,
                                  )
                                }
                                this.setState({ media_url: undefined })
                              }}
                              variant="contained"
                              color="secondary"
                              size="large"
                            >
                              <Email style={{ marginRight: 5 }} />
                              Email
                            </Button>
                          )}
                          {contact.phones && (
                            <Button
                              style={{ padding: '8px 12px' }}
                              disabled={!contact.phones}
                              onClick={() => {
                                toggleMessageMenu().then(() =>
                                  whatever(forwardedRef?.current?.offsetHeight),
                                )
                                if (this.props.messageType !== 'call') {
                                  if (this.props.messageType === 'text') {
                                    this.props.changeTo(
                                      'call',
                                      this.props.to,
                                      contact.id,
                                    )
                                  } else {
                                    this.props.changeTo(
                                      'call',
                                      contact?.phones?.[0]?.number,
                                      contact.id,
                                    )
                                  }
                                }
                                this.setState({ media_url: undefined })
                              }}
                              variant="contained"
                              color="secondary"
                              size="large"
                            >
                              <Call style={{ marginRight: 5 }} />
                              Call
                            </Button>
                          )}
                        </div>
                      )}
                      {messageMenuOpen && (
                        <>
                          {(messageType === 'text' ||
                            messageType === 'email') && (
                            <Hidden mdUp>
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  right: 58,
                                  transform: 'translateY(-50%)',
                                }}
                              >
                                <IconButton
                                  // disabled={sendButtonDisabled}
                                  classes={{ root: classes.iconButtonRoot }}
                                  style={{
                                    backgroundColor: sendButtonDisabled
                                      ? 'rgba(0, 0, 0, 0.12)'
                                      : undefined,
                                    color: sendButtonDisabled
                                      ? 'rgba(0, 0, 0, 0.26)'
                                      : undefined,
                                  }}
                                  onClick={() =>
                                    this.props.toggleDialog({
                                      dialog: 'scheduling',
                                      open: true,
                                      options: {
                                        text: this.state.text,
                                      },
                                    })
                                  }
                                >
                                  <Schedule />
                                </IconButton>
                              </div>
                            </Hidden>
                          )}
                          <div
                            style={{
                              position: 'absolute',
                              top: '50%',
                              right: 5,
                              transform: 'translateY(-50%)',
                            }}
                          >
                            <IconButton
                              classes={{ root: classes.iconButtonRoot }}
                              onClick={() => {
                                toggleMessageMenu().then(() =>
                                  whatever(forwardedRef?.current?.offsetHeight),
                                )
                              }}
                            >
                              {<ExpandMore />}
                            </IconButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      borderTop: '1px solid #ccc',
                      backgroundColor: '#fff',
                      minHeight: messageType === 'text' ? 48 : undefined,
                      position: 'relative',
                    }}
                  >
                    {messageType === 'text' ? (
                      <>
                        <Hidden smDown>
                          <EmojiMenu
                            disabled={this.props.sending}
                            disableAutoFocus
                            onEmojiClick={emoji => {
                              const { selectionStart, selectionEnd, text } =
                                this.state

                              const newText = `${text.slice(
                                0,
                                selectionStart,
                              )}${emoji}${text.slice(
                                selectionEnd,
                                text.length,
                              )}`

                              this.setState({
                                text: newText,
                                selectionStart: selectionStart + emoji.length,
                                selectionEnd: selectionStart + emoji.length,
                                length: newText.length,
                              })
                            }}
                          />
                        </Hidden>
                        <S3ManagerMenu
                          disabled={this.props.sending}
                          clickFile={media_url => {
                            this.setState({ media_url })
                          }}
                        />
                      </>
                    ) : null}
                    {component[messageType]}
                    {messageType === 'text' && this.state.media_url && (
                      <AttachmentPreview
                        mediaUrl={this.state.media_url}
                        onClose={() => this.setState({ media_url: undefined })}
                      />
                    )}
                    {messageType === 'text' || messageType === 'email' ? (
                      this.props.sending ? (
                        <CircularProgress
                          style={{
                            position: 'absolute',
                            top: 9,
                            right: 20,
                            width: 30,
                            height: 30,
                          }}
                        />
                      ) : (
                        sendAndSchedule
                      )
                    ) : null}
                    <Acknowledgement
                      callBack={status => {
                        if (status === 'created') {
                          if (messageType === 'text') {
                            this.sendSMS()
                          } else if (messageType === 'email') {
                            this.sendEmail()
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <SchedulingDialog
              dialogType="inbox"
              clearText={() => this.setState({ text: '' })}
            />
          </>
        )
      }
    },
  ),
)

export default forwardRef((props, ref) => (
  <ConnectedInput forwardedRef={ref} {...props} />
))
